<template>
	<div class="call-info-cls">
		<section v-if="list.length > 1 && isShow == false && StoreIsCallCurrentInfo.histId === row.histId">
			<div class="title-cls">相似客户</div>
			<table-pagination
				:data="list"
				:column="column" />
		</section>
		<section v-else>
			<CustomerInfo v-if="cId" sourceType="tel" :customerId="cId" :tuId="tId" />
		</section>

		<el-dialog title="客户详情" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="875px">
			<CustomerInfo v-if="cId" sourceType="tel" :customerId="cId" :tuId="tId" />
		</el-dialog>
	</div>
</template>



<script>
import { mapGetters } from 'vuex';
import CustomerInfo from "components/CustomerInfo/index";
export default {
	props: ['row'],
	components: {CustomerInfo},
	computed: {
		...mapGetters([
			'userInfo',
			'StoreIsCallCurrentInfo',
			'isShowPhone'
		])
	},
	data() {
		return {
			dialogFormVisible: false,
			isShow: false,
			list: [],
			column: [
				{
                    label: '序号',
                    width: 80,
                    render: (h, scope) => {
                        return <span>{scope.$index + 1}</span>
                    }
                },
				{ 
					label: '客户姓名', 
					prop: 'lastName',
					render: (h, scope) => {
                        return <span>{scope.row.lastName}{scope.row.firstName}</span>
                    } 
				},
				{ 
					label: '电话号码', 
					render: (h, scope) => {
                        return <span>{this.isShowPhone ? scope.row.phoneNumber : this.hiddenPhone(scope.row.phoneNumber)}</span>
                    } 
				},
				{ label: '客户描述', prop: 'customerDescribe' },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 100,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-button 
									onClick={() => this.handleView(scope.row)}
									type="text">
									详情
								</el-button>
								<el-button 
									onClick={() => this.handleConfirm(scope.row, '2')}
									type="text">
									确定
								</el-button>
							</div>
						)
                    }
                }
			],
			cId: '',
			tId: ''
		}
	},
	watch: {
		row: {
			handler: function(val) {
				if(this.StoreIsCallCurrentInfo?.histId) {
					this.getAllCustomerList();
				} else {
					this.cId = this.row.custId;
					this.tId = this.row.iaId;
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		handleView(row) {
			this.cId = row.customerId;
			this.tId = this.StoreIsCallCurrentInfo?.incidentId;
			this.dialogFormVisible = true;
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		handleConfirm(row) {
			this.cId = row.customerId;
			this.tId = this.StoreIsCallCurrentInfo?.incidentId;
			if(this.StoreIsCallCurrentInfo?.histId === this.row.histId) {
				// ! 修改来电记录
				Vue.prototype.$api.apiPostCallContactEdit({
					brand: this.userInfo.brandIdentify,
					histId: this.StoreIsCallCurrentInfo.histId,
					custId: row.customerId
				});
				// ! 修改沟通记录
				Vue.prototype.$api.apiPostUpdateCommunicate({
					brandId: this.userInfo.brandIdentify,
					histId: this.StoreIsCallCurrentInfo.histId,
					tuid: this.StoreIsCallCurrentInfo.incidentId,
					custId: row.customerId
				});
			}
			this.isShow = true;
		},
		getAllCustomerList() {
			this.$api.apiPostCustomerAllInfo({
				brand: this.userInfo.brandIdentify,
				phoneNumber: this.row.phoneNumber
			}).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				if(this.list.length == 1) {
					this.cId = this.list[0].customerId;
					this.tId = this.StoreIsCallCurrentInfo?.incidentId;
				}
			});
		},
	}
}
</script>

<style lang="scss" scoped>
.call-info-cls {
	width: 100%;
	margin-bottom: 20px;
	padding: 0 10px;
	box-sizing: border-box;

	& > .title-cls {
		width: 100%;
		line-height: 46px;
		font-weight: bold;
		
		font-size: 14px;
		color: #3C4353;
		font-weight: bold;
		vertical-align: top;
		user-select:none;
	}
}
</style>